import { type Components } from '@mui/material'
export const List: Partial<Components> = {
  MuiList: {
    styleOverrides: {
      root: {
        color: '#4D5E80',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontSize: 14,
        fontWeight: 700,
        letterSpacing: 0.01,
        padding: 8
      }
    }
  }
}
